module.exports = __webpack_public_path__ + "e6be2aaafd6ff69eed4e06d899400ac4.png";